export default {
  replySent: "Reply sent! Email notification sent to seller",
  internalNoteAdded: "Internal note added",
  sendMessageError: "Failed to send message",
  ticketMarked: "Ticket marked as {{label}}",
  updateStatusError: "Failed to update status",
  priorityUpdated: "Priority updated",
  updatePriorityError: "Failed to update priority",
} as const;
